import React from 'react';
import { BUTTON_SPINNER, RED_SPINNER } from "../../constant"

const SaveButton = (props) => {
    return (
        <>
            <button className={props.className} onClick={props.submit}>
                {!props.loader ? <>{props.buttonName}</> : <img src={props?.buttonName === "Delete" ? RED_SPINNER : BUTTON_SPINNER} style={{ height: "30px" }} alt="" />}
            </button></>
    )
}

export default SaveButton;
